import styled from '../styled';

import fromTheme from '../fromTheme';
import View from './View';

const Card = styled(View).attrs({ name: 'card' })`
    display: flex;
    flex-direction: column;
    min-width: ${fromTheme('card', 'minWidth')};
    box-shadow: ${({ shadow = true, theme }) => {
        if (!shadow) return 'unset';
        return theme.card?.boxShadow;
    }};
    height: 100%;
    flex-grow: 1;
    overflow: visible;
    background-color: ${fromTheme('card', 'backgroundColor')};
    border-radius: ${fromTheme('card', 'borderRadius')};
`;
Card.displayName = 'Card';

Card.Header = styled(View).attrs({ name: 'card-header' })`
    display: flex;
    flex-direction: row;
    background-color: ${fromTheme('card', 'header', 'backgroundColor')};
    color: ${fromTheme('card', 'header', 'textColor')};
    flex-shrink: 0;
    border-radius: ${fromTheme('card', 'borderRadius')} ${fromTheme('card', 'borderRadius')} 0 0;
    padding: ${fromTheme('card', 'header', 'padding')};
    ${fromTheme('card', 'header', 'font')};
`;
Card.Header.displayName = 'CardHeader';

Card.Body = styled(View).attrs({ name: 'card-body' })`
    display: flex;
    flex-direction: column;
    background-color: transparent;
    border-top: ${fromTheme('card', 'body', 'border')};
    height: 100%;
    padding: ${fromTheme('card', 'body', 'padding')};
    ${fromTheme('card', 'body', 'font')};
`;
Card.Body.displayName = 'CardBody';

Card.Footer = styled(View).attrs({ name: 'card-footer' })`
    flex-direction: row;
    display: flex;
    background-color: ${fromTheme('card', 'footer', 'backgroundColor')};
    padding: ${fromTheme('card', 'footer', 'padding')};
    border-top: ${fromTheme('card', 'body', 'border')};
    flex-shrink: 0;
`;
Card.Footer.displayName = 'CardFooter';

Card.Divider = styled(View).attrs({ name: 'card-divider' })``;
Card.Divider.displayName = 'CardDivider';

export default Card;
